import React, { useState } from 'react';

// Types
import { ReviewTemplateType } from 'Shared/types/ReviewTemplates.type';
import { FeedbackRecognitionTemplateTypes } from 'Shared/constants/types';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Components
import FeedbackTemplateSelect from 'Dashboard/components/GiveFeedbackPage/FeedbackTemplateSelect';
import GiveFeedbackOrKudosModal from 'Shared/components/GiveFeedbackOrKudosModal/GiveFeedbackOrKudosModal';

const CoachingFeedbackTemplates = () => {
  const [template, setTemplate] = useState<FeedbackRecognitionTemplateTypes | string>(null);
  const [reviewTemplateSlug, setReviewTemplateSlug] = useState<string>(null);

  const [isGiveFeedbackOrKudosModalOpen, toggleIsGiveFeedbackOrKudosModalOpen] = useToggle(false);

  const handleCloseIsGiveFeedbackOrKudosModalOpen = () => {
    setTemplate(null);
    setReviewTemplateSlug(null);
    toggleIsGiveFeedbackOrKudosModalOpen();
  };

  const handleSelectTempalte = ({ template }: { template: ReviewTemplateType }) => {
    if (template.isCustom) {
      setTemplate(FeedbackRecognitionTemplateTypes.feedbackfromReviewTemplateTemplate);
      setReviewTemplateSlug(template.slug);
    } else {
      setTemplate(template.slug);
    }

    toggleIsGiveFeedbackOrKudosModalOpen();
  };

  return (
    <>
      <FeedbackTemplateSelect handleChooseTemplate={handleSelectTempalte} />
      <GiveFeedbackOrKudosModal
        flow="feedback"
        isOpen={isGiveFeedbackOrKudosModalOpen}
        toggleIsOpen={handleCloseIsGiveFeedbackOrKudosModalOpen}
        template={template}
        reviewTemplateSlug={reviewTemplateSlug}
      />
    </>
  );
};

export default CoachingFeedbackTemplates;
